// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AccidentPdfFileWidget__Component[data-v-15eed2a3] {\n  padding: 10px;\n}\na[data-v-15eed2a3] {\n  display: block;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
